import Moment from 'moment';

// ISO_8601 is required: the simulator stores a lead's start date as an ISO string
const ACCEPTED_FORMATS = [Moment.ISO_8601, 'YYYY-MM-DD', 'DD/MM/YYYY'];

// a single strict parse - an OR of two parse attempts always lets the permissive branch win
const parseDate = (d) => typeof d === 'string' ? Moment(d, ACCEPTED_FORMATS, true) : Moment(d);

export const conditions = {
  isAboveMin(d, min) {
    return parseDate(d).isSameOrAfter(min, 'day');
  },

  isUnderMax(d, max) {
    return parseDate(d).isSameOrBefore(max, 'day');
  },

  isValidDate(d) {
    /* when d is 'null' there's another test for it ('required') */
    if (d instanceof Date || d === null) {
      return !Number.isNaN(d);
    } else {
      return parseDate(d).isValid();
    }
  },
};
